'use client';

import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import * as fbq from './fbq';

const sendPageView = () => {
  console.log('Sending FB Pixel page view track');
  fbq.pageview();
};

export const FacebookPixel = () => {
  const [loaded, setLoaded] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (!loaded) return;
    sendPageView();
  }, [location, loaded]);

  return (
    <script
      id="fb-pixel"
      // strategy="afterInteractive"
      onLoad={() => setLoaded(true)}
    >
      {`!function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', '${process.env.NEXT_PUBLIC_FB_PIXEL_ID}');`}
    </script>
  );
};
